function formatZero (num) {
  if (num < 10) {
    return '0' + num
  } else {
    return num
  }
}
export default {
  formatDate: function (timestamp) {
    if (timestamp === null) {
      return timestamp
    }
    if (timestamp === '') {
      return timestamp
    }

    let date = new Date(timestamp)
    let timeString = ''
    timeString += date.getFullYear() + '-'
    timeString += formatZero(+date.getMonth() + 1) + '-'
    timeString += formatZero(date.getDate())
    return timeString
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js